import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';
import {MedicalReportModel} from '../../../api/entity/medicalReport.model';

@Injectable()
export class MedicalReportRepository extends AbstractRepositoryV2<MedicalReportModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('MedicalReport', serviceElementsFactory, injector);
    }
}
